import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading || store[NAME].sendingMail;
export const getData = store => store[NAME].data;
export const getResumeData = store => store[NAME].resumeData;
export const getInitialData = store => store[NAME].initialData;